import {Fragment, useContext, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {OrderContext} from "../../context/OrderContext";
import {UserContext} from "../../context/UserContext";
import { BsCardChecklist } from "react-icons/bs";
import { GoDownload, GoEye  } from "react-icons/go";
import {FileContext} from "../../context/FileContext";
import { OrderReviewFileUploader } from "../orderElements/files/orderReviewFileUploader";
import { APIPostOrderLinkedMessaging} from "../../api/orders/OrdersMessaging";
import { S3DeleteAllFilesInDirectory, S3DeleteFile, S3GetFileUrl } from '../../helper/s3ClientHandler';
import { getFormatedFileSize } from '../../helper/fileSizeFormatter';
import { SlTrash } from "react-icons/sl";
import { FileIcon } from '../FileIcon';
import { v4 } from 'uuid';


export default function StartReview() {
    const {openOrderStartReviewModal, setOpenOrderStartReviewModal,order, getOrder, saveOrder} = useContext(OrderContext);
    const {user} = useContext(UserContext);
    const cancelButtonRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [areValidFiles, setAreValidFiles] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const orderEdit = true;
    const [reviewVersion, setReviewVersion] = useState(Date.now());
    const reviewUploadPath = `${order?.createdByCompany}/orders/${order?.id.replaceAll("-", '/')}/review/${reviewVersion}`

    const onFilesUploaded = async ({files}) => {
        const newFiles = [...uploadedFiles, ...files];
        const filteredFiles = newFiles.filter((file, index, self) =>
          index === self.findIndex((f) => f.name === file.name)
        );
        setUploadedFiles(filteredFiles);
        checkGmlFile(filteredFiles);
    }

    const checkGmlFile = (files) => {
        if (!files || files.length < 1) {
            setAreValidFiles(false)
            return;
        }; 
        if (files.filter(file => file.type === 'GML').length > 0) {
            setAreValidFiles(true);
            return;
        }
        setAreValidFiles(false);
    }

    const onReviewCancel = async () => {
    setLoading(true);
    if (uploadedFiles.length > 0) {
        await S3DeleteAllFilesInDirectory(reviewUploadPath);
    }
    setUploadedFiles([]);
    setOpenOrderStartReviewModal(false);
    setLoading(false);
    setReviewVersion(Date.now());
    }

    const removeFileFromUploadedFiles = (fileKey) => {
        const newFiles = uploadedFiles.filter((file) => file.key !== fileKey);
        setUploadedFiles(newFiles);
        checkGmlFile(newFiles);
    }

    const handleDeleteFile = async (fileKey) => {
        await S3DeleteFile(fileKey);
        removeFileFromUploadedFiles(fileKey);
    }

    const getContentAfterSecondLastSlash = (str) => {
        const parts = str?.split('/');
        // Get the content after the second last '/'
        const content = parts?.slice(-2).join('/');
        const fileName = content?.split('/').pop();
        return content.replace(fileName, fileName).split('.')[0];
    }


    const generateDownloadUrl = async (s3Key) => {
        try {
            const url = await S3GetFileUrl(s3Key);
            const link = document.createElement('a');
            link.href = url;
            link.download = s3Key.split("/").pop();
            link.click();
        } catch (error) {
            console.error('Error generating download URL:', error);
        }
    };

    const getFileFromUrl = (url) => {
        const fileIdWithFileName = getContentAfterSecondLastSlash(url);
        const fileId = fileIdWithFileName?.split('/')[0];
        const filename = fileIdWithFileName?.split('/')[1];
        return {fileId, filename};
    }

    const submitReview = async () =>  {
        if (loading || !areValidFiles) return;
        // TODO: Wenn Abnahme zurueck gezogen - kennzeicnung in Version (Zurueckgezogen)
        const newOrder  = {...order};
        let version = 1;


        if(typeof newOrder?.reviewDetails !== "undefined") {
            for (var a = 0; a < newOrder?.reviewDetails?.length; a++){
                newOrder.reviewDetails[a].status = "archived"
            }

            // set current version
            version = newOrder?.reviewDetails?.length + 1;
        } else {
            newOrder.reviewDetails = [];
        }

        newOrder?.reviewDetails?.push({
            reviewId: v4(),
            version: version,
            status: "active",
            creationDate: reviewVersion,
            path: reviewUploadPath,
        })

        const messageData = {
            ordersId : order?.id,
            linkId : order?.id,
            linkType : "progressUpdate",
            createdByUser : user?.id,
            createdByUserName : user?.name,
            createdByCompany : user?.companyId,
            createdByCompanyName : user?.companyId,
            message : "Die bearbeitung des Auftrages wurden abgeschlossen. Der Auftrag kann nun geprüft und abgenommen werden.",
            orderCompany: order?.createdByCompany,
            orderCompanyUser: order?.createdByUser,
            contractedCompany: order?.contractedCompany,
            planId: order?.planId,
        }


        try {
            await saveOrder("inReview", order?.id, newOrder);
            await APIPostOrderLinkedMessaging({messageData, companyId: user?.companyId});
            setOpenOrderStartReviewModal(false)
            setReviewVersion(Date.now());
        } catch (error) {
            console.error('Error submitting review:', error);
        }
        setUploadedFiles([]);
        await getOrder();
    }

    return (
        <Transition.Root show={openOrderStartReviewModal} as={Fragment}>
            <Dialog 
                className="relative z-10" 
                initialFocus={cancelButtonRef} 
                onClose={setOpenOrderStartReviewModal}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                                <div className="bg-white px-4 pt-6 ">
                                    <div className="sm:flex sm:items-start">
                                        <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg flex gap-4 mb-4 mt-2 font-bold leading-6 text-gray-900">
                                            <BsCardChecklist className="h-6 w-6" aria-hidden="true" /> <span>Abnahme vorbereiten</span>
                                            </Dialog.Title>

                                            <p className="text-sm  block text-gray-600">Um Ihren Auftrag abzuschließen, bedarf es einer finalen Abnahme durch den Auftraggeber/in. Laden Sie nun sämtliche Abnahme relevante Dokumente hoch, welche geprüft werden soll.</p>

                                            <div className={"mb-4"}>
                                                <FileContext.Provider className={"wrapper"} value={{order, orderEdit}}>
                                                    <OrderReviewFileUploader 
                                                        path={reviewUploadPath}
                                                        loading={loading}
                                                        setLoading={setLoading}
                                                        onFilesUploaded={onFilesUploaded}
                                                    />
                                                </FileContext.Provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {uploadedFiles.length > 0 && (
                                    <div className="bg-white p-6">
                                        <ul className="list-disc flex flex-col list-inside gap-2">
                                            {uploadedFiles.map((file, index) => {
                                                const fileExtension = file.name.split('.').pop().toLowerCase();
                                                return (
                                                    <li key={`gml-${index}`} className="flex items-center rounded-lg  text-sm leading-6 bg-gray-200 py-2 px-2">
                                                        <FileIcon fileExtension={fileExtension} />
                                                        <div className='flex gap-2 w-full truncate ml-2'>
                                                            <div className='truncate flex-1'>
                                                                <h3 className=' truncate'>{file.name}</h3>
                                                                <div className='flex gap-4'>
                                                                    <p className='text-gray-600 w-24'>{file.type} Datei</p>
                                                                    <p className='text-gray-600 sm:visible invisible'>{getFormatedFileSize(+file.size)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='flex gap-4 sm:pr-4'>
                                                            {fileExtension === 'gml' && (
                                                                <button 
                                                                    target={"_blank"} 
                                                                    onClick={ () => window.open(`/viewer?fId=${getFileFromUrl(file.key).fileId}&f=${getFileFromUrl(file.key).filename}&cId=${order?.createdByCompany}&vId=${reviewVersion}&oId=${order?.id}`)}   
                                                                    className="cursor-pointer flex flex-col items-center"
                                                                >
                                                                    <GoEye  className={"h-[20px] w-[20px] flex-none text-gray-900"}/>
                                                                    <div className='sm:flex hidden'>
                                                                        <div className='text-[10px] h-[20px] leading-1 whitespace-nowrap'>Plan öffnen</div>
                                                                    </div>
                                                                </button>
                                                            )}
                                                            <button 
                                                                onClick={() => generateDownloadUrl(file.key)}  
                                                                className="cursor-pointer flex flex-col items-center"
                                                            >
                                                                <GoDownload   className={"h-[20px] w-[20px] flex-none text-gray-900"}/>
                                                                <div className='sm:flex hidden'>
                                                                    <div className='text-[10px] h-[20px] leading-1 whitespace-nowrap'>Download</div>
                                                                </div>
                                                            </button>
                                                            <button onClick={() => handleDeleteFile(file.key)}
                                                                className="group cursor-pointer flex flex-col items-center "
                                                            >
                                                                <SlTrash className="h-[20px] w-[20px] group-hover:text-red flex-none text-gray-900"  aria-hidden="true"/>
                                                                <div className='sm:flex hidden'>
                                                                    <span className='text-[10px] h-[20px] group-hover:text-red leading-1'>löschen</span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </li>
                                            )})}
                                        </ul>
                                    </div>
                                )}
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        className={`disabled:bg-gray-500 inline-flex w-full justify-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
                                        disabled={!areValidFiles || loading}
                                        onClick={submitReview}
                                    >
                                        Abnahme starten
                                    </button>
                                    <button
                                        type="button"
                                        disabled={loading}
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={onReviewCancel}
                                        ref={cancelButtonRef}
                                    >
                                        Schließen
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
